const WISHLIST_KEY = 'swtekWishlist';

const getWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  } catch {
    return [];
  }
};

const saveWishlist = (wishlist) => {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
};

const updateButtons = () => {
  const wishlist = getWishlist();

  document.querySelectorAll('.add-to-wishlist').forEach((button) => {
    const handle = button.dataset.productHandle;
    const currentIcon = button.querySelector('.wishlist-icon-current');
    const nextIcon = button.querySelector('.wishlist-icon-next');
    const text = button.querySelector('p');

    const active = wishlist.includes(handle);

    button.classList.toggle('is-wishlisted', active);
    button.setAttribute('aria-pressed', active);

    if (currentIcon) {
      currentIcon.textContent = active ? 'favorite' : 'heart_plus';
    }

    if (nextIcon) {
      nextIcon.textContent = active ? 'heart_plus' : 'favorite';
    }

    if (text) {
      text.innerHTML = active
      ? 'Added to<br>Wishlist'
      : 'Add to<br>Wishlist';
    }
  });
};
const showWishlistAddedBadge = (button) => {
    console.log("Added trigger");
  const badge = button.querySelector(
    '.wishlist-added-badge'
  );

  if (!badge) return;

  clearTimeout(button._wishlistBadgeTimer);

  badge.classList.add('is-visible');

  button._wishlistBadgeTimer = setTimeout(() => {
    badge.classList.remove('is-visible');
  }, 1600);
};
const animateWishlistIcon = (button, active) => {
  const stack = button.querySelector('.wishlist-icon-stack');
  const currentIcon = button.querySelector('.wishlist-icon-current');
  const nextIcon = button.querySelector('.wishlist-icon-next');
  const text = button.querySelector('p');

  if (!stack || !currentIcon || !nextIcon) return;

  button.classList.toggle('is-wishlisted', active);
  button.setAttribute('aria-pressed', active);

  if (text) {
    text.innerHTML = active
    ? 'Added to<br>Wishlist'
    : 'Add to<br>Wishlist';
  }

  // The icon that should roll in
  nextIcon.textContent = active ? 'favorite' : 'heart_plus';

  // Prevent repeated clicks while rolling
  if (stack.classList.contains('is-rolling')) return;

  stack.classList.add('is-rolling');

  setTimeout(() => {
    // New state becomes the resting/current icon
    currentIcon.textContent = active ? 'favorite' : 'heart_plus';

    // Prepare the hidden next icon for the opposite state
    nextIcon.textContent = active ? 'heart_plus' : 'favorite';

    stack.classList.remove('is-rolling');
  }, 380);
};
const showPdpWishlistToast = () => {
  const toast = document.getElementById('PdpWishlistToast');
  if (!toast) return;

  clearTimeout(toast._hideTimer);
  clearTimeout(toast._removeTimer);

  // Reset previous animation
  toast.classList.remove('is-visible', 'is-leaving');

  // Force browser to register the reset
  void toast.offsetWidth;

  // Slide in
  toast.classList.add('is-visible');

  // Stay visible for 2.4 seconds
  toast._hideTimer = setTimeout(() => {
    toast.classList.add('is-leaving');

    // Clean up after exit animation
    toast._removeTimer = setTimeout(() => {
      toast.classList.remove('is-visible', 'is-leaving');
    }, 400);
  }, 2400);
};
document.addEventListener('click', (event) => {
  const button = event.target.closest('.add-to-wishlist');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const handle = button.dataset.productHandle;
  let wishlist = getWishlist();

  const wasAlreadyWishlisted = wishlist.includes(handle);

if (wasAlreadyWishlisted) {
  wishlist = wishlist.filter((item) => item !== handle);
} else {
  wishlist.push(handle);
}

  saveWishlist(wishlist);

const nowWishlisted = !wasAlreadyWishlisted;

animateWishlistIcon(button, nowWishlisted);
  // Only show when ADDED
  if (nowWishlisted) {
  showWishlistAddedBadge(button);
    showPdpWishlistToast();
}
  document.dispatchEvent(
    new CustomEvent('swtek:wishlist-updated', {
      detail: { count: wishlist.length }
    })
  );
});

document.addEventListener('DOMContentLoaded', updateButtons);